// extracted by mini-css-extract-plugin
export default {"sentinel":"infinite-scroll_sentinel__SvJnO","wrap":"infinite-scroll_wrap__FBcUY"};